/** The fold chevron of the grouped pickers (Explorer, Upload to sensors):
 *  points right when folded; the fold button's `aria-expanded` turns it
 *  down (pages/explorer.css, components/documents.css). */
export const Chevron = () => (
  <svg className="explore-chevron" width="10" height="10" viewBox="0 0 24 24" aria-hidden="true">
    <path d="m9 5 7 7-7 7" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"
          strokeLinejoin="round" />
  </svg>
)
